import { render, staticRenderFns } from "./UploadEvidence.vue?vue&type=template&id=4d76285a"
import script from "./UploadEvidence.vue?vue&type=script&lang=js"
export * from "./UploadEvidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports